<app-alerts />

@if (data$ | async; as data) {
  <app-admin-dictionary-country-details-form
    [data]="data"
    (submitClickEvent)="handleSubmitClickEvent($event)" />
} @else {
  <app-spinner-filled />
}
